export class ScrollStateManager {
  constructor() {
    this.body = document.querySelector('body');
    this.mainVisual = document.querySelector('#main-visual');
    this.threshold = this.mainVisual ? this.mainVisual.offsetHeight : 0;
    this.lastScroll = 0;
    this.topClass = 'js-is-top';
    this.upClass = 'js-is-scrolling-up';
    this.downClass = 'js-is-scrolling-down';

    this.fire();
    window.addEventListener('scroll', this.fire.bind(this), {passive: true});
  }

  fire() {
    var scrollPosition = window.scrollY;
    var scrollingUp = scrollPosition < this.lastScroll;
    this.lastScroll = scrollPosition;

    // しきい値を超えていない場合は処理を終了
    // TODO: バグあるかも
    if (scrollPosition <= this.threshold) {
      this.body.classList.add(this.topClass);
      this.body.classList.remove(this.upClass, this.downClass);
      return;
    }

    this.body.classList.remove(this.topClass);

    if (scrollingUp) {
      this.body.classList.add(this.upClass);
      this.body.classList.remove(this.downClass);
    } else {
      this.body.classList.add(this.downClass);
      this.body.classList.remove(this.upClass);
    }
  }
}
